import React from 'react';
import { alpha } from '@mui/material/styles';
import { severityMapping } from './severityMapping';
import type { ToastAlertProps } from './index';
// Follow this on how to!!!
export const AlertIcon = ({ severity }: { severity: ToastAlertProps['severity'] }) => {
  if (!severity) return null;
  const { icon, color } = severityMapping[severity];
  return (
    <div
      style={{
        width: '34px',
        height: '34px',
        borderRadius: '24px',
        border: `2px solid ${alpha(color, 0.1)}`,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        boxSizing: 'border-box',
      }}
    >
      <div
        style={{
          width: '26px',
          height: '26px',
          borderRadius: '24px',
          border: `2px solid ${alpha(color, 0.3)}`,
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          boxSizing: 'border-box',
        }}
      >
        {icon}
      </div>
    </div>
  );
};
